var _path, _path2, _path3, _g, _path4, _path5, _path6, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4033 23.9585C14.4033 21.9141 14.4033 23.1918 14.4033 14.7585C14.4033 3.25854 32.5969 3.25856 32.5969 14.7585C32.5969 23.9585 32.5969 35.714 32.5969 36.9918",
    stroke: "#BCBBBE",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58105 22.9333C7.58105 21.2765 8.9242 19.9333 10.5811 19.9333H36.4197C38.0766 19.9333 39.4197 21.2765 39.4197 22.9333V39C39.4197 42.866 36.2857 46 32.4197 46H14.5811C10.7151 46 7.58105 42.866 7.58105 39V22.9333Z",
    fill: "#FEDC33"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_517_72288",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 19,
    width: 33,
    height: 27
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58105 22.9333C7.58105 21.2765 8.9242 19.9333 10.5811 19.9333H36.4197C38.0766 19.9333 39.4197 21.2765 39.4197 22.9333V39C39.4197 42.866 36.2857 46 32.4197 46H14.5811C10.7151 46 7.58105 42.866 7.58105 39V22.9333Z",
    fill: "#FEDC33"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_517_72288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.7108,
    height: 25.6073,
    transform: "matrix(0.874906 -0.484293 0.475956 0.879469 0 43.0391)",
    fill: "#F0C11C"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7745 36.5381C27.5411 35.9066 28.8067 34.2027 28.8067 32.1998C28.8067 29.6593 26.7703 27.5999 24.2583 27.5999C21.7463 27.5999 19.71 29.6593 19.71 32.1998C19.71 34.2027 20.9757 35.9066 22.7423 36.5381V41.4001H25.7745V36.5381Z",
    fill: "#2B3035"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.03226 7.66675L4.07001 9.68388L6.06451 10.7334L4.07001 11.7829L3.03226 13.8001L1.9945 11.7829L0 10.7334L1.9945 9.68388L3.03226 7.66675Z",
    fill: "#FEDC33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9678 0L45.0056 2.01713L47.0001 3.06666L45.0056 4.11619L43.9678 6.13332L42.93 4.11619L40.9355 3.06666L42.93 2.01713L43.9678 0Z",
    fill: "#FEDC33"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2583,
    cy: 32.1998,
    rx: 1.51613,
    ry: 1.53333,
    fill: "#3B434A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.30708e43543f716647744b63f2ea8895.svg";
export { ForwardRef as ReactComponent };